"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TimeMysqlHandler", {
    enumerable: true,
    get: function() {
        return TimeMysqlHandler;
    }
});
const _timegeneralhandler = require("~/db/field-handler/handlers/time/time.general.handler");
let TimeMysqlHandler = class TimeMysqlHandler extends _timegeneralhandler.TimeGeneralHandler {
    getTimeFormat() {
        return 'YYYY-MM-DD HH:mm:ss';
    }
};
